import React from 'react'
import cx from 'classnames'

import Bolt from './bolt.js'

import './style.css'

const Hint = ({ completed, children }) => (
  <li className={cx('hints', { completed })}><Bolt/>{children}</li>
)

const PasswordHints = ({
  hasTen,
  hasSpecial,
  hasFourUnique,
  className,
}) => {
  const isSecurePassword = hasSpecial && hasTen && hasFourUnique
  return (
    <div className={cx('password-hints', `${className}`)}>
      { !isSecurePassword && 
        <ul>
          <Hint completed={hasTen}>10 characters minimum</Hint>
          <Hint completed={hasSpecial}>One special character</Hint>
          <Hint completed={hasFourUnique}>Four unique characters</Hint>
        </ul>
      }
      { isSecurePassword && 
        <div className="password-verification">
          <Bolt/>
          <span>Sweet! Your password is secure</span>
        </div>
      }
    </div>
  )
}

export default PasswordHints


// WEBPACK FOOTER //
// ./src/layouts/PasswordHints/index.js